import { render, staticRenderFns } from "./form.vue?vue&type=template&id=093a10c6&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('093a10c6')) {
      api.createRecord('093a10c6', component.options)
    } else {
      api.reload('093a10c6', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=093a10c6&", function () {
      api.rerender('093a10c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/announcement/form.vue"
export default component.exports